import { render, staticRenderFns } from "./giftSort.vue?vue&type=template&id=039871f4&"
import script from "./giftSort.vue?vue&type=script&lang=js&"
export * from "./giftSort.vue?vue&type=script&lang=js&"
import style0 from "./giftSort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039871f4')) {
      api.createRecord('039871f4', component.options)
    } else {
      api.reload('039871f4', component.options)
    }
    module.hot.accept("./giftSort.vue?vue&type=template&id=039871f4&", function () {
      api.rerender('039871f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giftActivity/giftSort.vue"
export default component.exports